import "./styles.css";
import Content from "./Content";
import Qr from "./QR";
import Text from "./Text";

function App() {
  return (
    <Content>
      <Qr />
      <Text />
    </Content>
  );
}

export default App;
